import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import SellerSidebar from "./common/SellerSidebar";
import ProfileSidebar from "../pages/common/ProfileSidebar";

function TrackOrder({ orderData }) {
  const [trackingId, setTrackingId] = useState("");
  const [submittedId, setSubmittedId] = useState(null); 
  const [showStatus, setShowStatus] = useState(false);


  // Fake data (replace with backend response later)
  const defaultOrderData = {
    statusProgress: 60,
    steps: [
      { title: "Order Placed", date: "12-06-2025" },
      { title: "Order Ready", date: "14-06-2025" },
      { title: "Order Shipped", date: "14-06-2025" },
      { title: "Estimated Delivery", date: "16-06-2025" },
    ],
    updates: [
      {
        date: "12-06-2025 , 09:34:00",
        location: "Coast, Singapore",
        status: "Shipped",
        note: null,
      },
      {
        date: "13-06-2025 , 11:10:00",
        location: "Coast, Singapore",
        status: "Ready",
        note: "Waiting to ship",
      },
      {
        date: "14-06-2025 , 15:00:00",
        location: "Coast, Singapore",
        status: "Awaiting order",
        note: null,
      },
    ],
  };

  const data = orderData || defaultOrderData;

  const handleShowStatus = () => {
    if (!trackingId.trim()) {
      alert("Please enter a tracking ID");
      return;
    }
    setSubmittedId(trackingId); 
    setShowStatus(true);
  };

  return (
    <div className="all_suport_bg manages_top">
      <section className="ser_v_araeea profiles">
        <div className="container">
          <div className="bradcams">
            <span className="bothss">
              <Link to="">Dashboard</Link>{" "}
              <img src="/images/brd_rowwo.png" alt="" /> Store
              <img src="/images/brd_rowwo.png" alt="" /> Track Order
            </span>
          </div>

          <div className="row">
            <div className="col-lg-3 mb_view_hide">
              <SellerSidebar />
            </div>

            <div className="col-lg-9">
              <div className="form_boxx profilss">
                <h3 className="bulk-product-title">Track Orders</h3>
              </div>

              {/* Tracking Input */}
              <div className="form_boxx bg-white mb-5">
                <h5 className="bulk-upload-title">Tracking ID</h5>
                <label className=" upload-input track-order ">
                  <input
                    type="text"
                    className="upload-control "
                    placeholder="Enter tracking ID"
                    value={trackingId}
                    onChange={(e) => setTrackingId(e.target.value)}
                  />
                </label>

                <div className="text-center">
                  <button
                    className="bulk-upload-submit"
                    onClick={handleShowStatus}
                  >
                    Show Status
                  </button>
                </div>
              </div>

              {/* Animated Order Status & Updates */}
              <AnimatePresence>
                {showStatus && (
                  <motion.div
                    key={submittedId} 
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 30 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                  >
                    {/* Order Status */}
                    <div className="mb-5">
                      <h3 className="bulk-product-title mb-3">Order Status</h3>
                      <motion.div
                        className="order-progress"
                        initial={{ width: 0 }}
                        animate={{ width: "100%" }}
                        transition={{ duration: 0.8 }}
                      >
                        <div className="track"></div>
                        <motion.div
                          className="fill"
                          initial={{ width: 0 }}
                          animate={{ width: `${data.statusProgress}%` }}
                          transition={{ duration: 1, ease: "easeInOut" }}
                        ></motion.div>
                      </motion.div>
                      <div className="order-steps">
                        {data.steps.map((step, index) => (
                          <motion.div
                            key={index}
                            className="step"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.2 }}
                          >
                            <span className="step-title">{step.title}</span>
                            <span className="step-date">{step.date}</span>
                          </motion.div>
                        ))}
                      </div>
                    </div>

                    {/* Updates */}
                    <div className="mt-4">
                      <h3 className="bulk-product-title mb-3">Updates</h3>
                      <div className="updates-table">
                        <div className="updates-header">
                          <div>Date</div>
                          <div>Location</div>
                          <div>Status</div>
                        </div>
                        {data.updates.map((update, index) => (
                          <motion.div
                            className="updates-row"
                            key={index}
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: index * 0.2 }}
                          >
                            <div>{update.date}</div>
                            <div>{update.location}</div>
                            <div>
                              <span
                                className={`status-badge ${update.status.toLowerCase()}`}
                              >
                                {update.status}
                              </span>
                              {update.note && (
                                <div className="status-note">{update.note}</div>
                              )}
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TrackOrder;
